<template>
  <Icon icon="svg-spinners:ring-resize" :class="spinnerClasses" />
</template>
<script lang="ts" setup>
import { computed } from 'vue'
import { Icon } from '@iconify/vue'
const props = defineProps<{
  class?: string
  size?: 'small' | 'middle' | 'large' | 'default' | undefined
}>()

const spinnerClasses = computed(() => {
  switch (props.size) {
    case 'small':
      return '!h-8 !w-8'
    case 'middle':
      return '!h-20 !w-20'
    case 'large':
      return '!h-24 !w-24'
    case 'default':
    default:
      return '!h-16 !w-16'
  }
})
</script>
